import {gql} from "@apollo/client";

export const getCartItems = gql`
  query getCartItems {
    carts {
      id
      text
      ingredientId
      cut
      ingredient { name }
    }
  }
`;

export const deleteCartItem = gql`
  mutation deleteCartItem($id: ID!){
    deleteFromCart(
      input: {id: $id}) {
      cart {
        id
      }
    }
  }
`
export const cutCartItem = gql`
  mutation cutCartItem($id: ID!){
    cutFromCart(
      input: {id: $id}) {
      cart {
        id
      }
    }
  }
`

export const deleteAllCartItem = gql`
  mutation deleteAllCartItem {
    emptyCart(input: {}){
      success
    }
  }
`